<template>
  <div>
    <AllCases :validationStatus="validation"></AllCases>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const AllCases = defineAsyncComponent(() =>
  import("@/components/cases/AllCases")
);
export default {
  components: {
    AllCases,
  },
  data() {
    return {
        validation:true
    };
  },
};
</script>
